var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Board/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { boardGraphic } from './../../../../components/Fretboard/Skins/skins';
import ViewPort from './../../../Fretboard/Neck/ViewPort';
import BoardPositions from './BoardPositions';

const Board = ({
  tuning,
  nrOfFrets,
  strHighlight,
  skinType,
  width,
  offset,
  selectedStrings,
  fretHighlight,
  fretHighlightColor
}) => {
  const BoardGraphic = boardGraphic(skinType);
  const nrOfStrings = tuning.length;
  console.log('from Fretboard/Neck/Board/index.js: selectedStrings: ' + selectedStrings)
  console.log('from Fretboard/Neck/Board/index.js: fretHighlight: ')
  console.dir(fretHighlight)
  console.log('from Fretboard/Neck/Board/index.js: fretHighlightColor: ' + fretHighlightColor)
  return /*#__PURE__*/React.createElement(ViewPort, _extends({
    width,
    offset
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(BoardGraphic, _extends({
    nrOfStrings,
    nrOfFrets,
    selectedStrings,
    fretHighlight,
    fretHighlightColor
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(BoardPositions, _extends({
    tuning,
    nrOfFrets
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  })));
};

Board.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  nrOfFrets: pt.number.isRequired,
  skinType: pt.string.isRequired,
  width: pt.number.isRequired,
  offset: pt.number.isRequired,
  selectedStrings: pt.arrayOf(pt.string).isRequired,
  fretHighlight: pt.arrayOf(pt.number),
  fretHighlightColor: pt.string
};
export default Board;
